import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Image from '../../../components/AppImage';

const MemberLookup = ({ onMemberSelect }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const mockMembers = [
  {
    id: 1,
    name: "Sarah Johnson",
    email: "sarah.j@email.com",
    phone: "(555) 123-4567",
    membershipId: "GYM-2024-001",
    status: "active",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16e2660d5-1763296451457.png",
    avatarAlt: "Professional headshot of woman with blonde hair in white blouse smiling at camera",
    lastCheckIn: "2026-01-25T14:30:00"
  },
  {
    id: 2,
    name: "Michael Chen",
    email: "m.chen@email.com",
    phone: "(555) 234-5678",
    membershipId: "GYM-2024-002",
    status: "expiring",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_165b055d2-1763293612537.png",
    avatarAlt: "Professional headshot of Asian man with short black hair in navy suit",
    lastCheckIn: "2026-01-24T18:15:00"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    email: "emily.r@email.com",
    phone: "(555) 345-6789",
    membershipId: "GYM-2024-003",
    status: "active",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18c4732a5-1763293920448.png",
    avatarAlt: "Professional headshot of Hispanic woman with long brown hair in business attire",
    lastCheckIn: "2026-01-25T16:00:00"
  }];


  const handleSearch = (query) => {
    setSearchQuery(query);
    setIsSearching(true);

    setTimeout(() => {
      if (query?.trim()) {
        const results = mockMembers?.filter((member) =>
        member?.name?.toLowerCase()?.includes(query?.toLowerCase()) ||
        member?.email?.toLowerCase()?.includes(query?.toLowerCase()) ||
        member?.membershipId?.toLowerCase()?.includes(query?.toLowerCase())
        );
        setSearchResults(results);
      } else {
        setSearchResults([]);
      }
      setIsSearching(false);
    }, 300);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success';
      case 'expiring':
        return 'bg-warning/10 text-warning';
      case 'expired':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="card">
      <h2 className="text-xl font-semibold text-foreground mb-6">Member Lookup</h2>
      <div className="relative mb-4">
        <Input
          type="search"
          placeholder="Search by name, email, or member ID..."
          value={searchQuery}
          onChange={(e) => handleSearch(e?.target?.value)}
          className="mb-0" />

        <div className="absolute right-3 top-1/2 -translate-y-1/2">
          {isSearching ?
          <Icon name="Loader2" size={20} className="animate-spin text-muted-foreground" /> :

          <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
          }
        </div>
      </div>
      {searchQuery &&
      <div className="space-y-3 max-h-[400px] overflow-y-auto custom-scrollbar">
          {searchResults?.length > 0 ?
        searchResults?.map((member) =>
        <div
          key={member?.id}
          onClick={() => onMemberSelect(member)}
          className="p-4 rounded-lg bg-muted/30 hover:bg-muted/50 cursor-pointer transition-colors">

                <div className="flex items-center gap-4">
                  <Image
              src={member?.avatar}
              alt={member?.avatarAlt}
              className="w-12 h-12 rounded-full object-cover" />


                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="text-sm font-semibold text-foreground truncate">
                        {member?.name}
                      </h3>
                      <span className={`text-xs px-2 py-0.5 rounded-full ${getStatusColor(member?.status)}`}>
                        {member?.status}
                      </span>
                    </div>
                    <div className="space-y-1">
                      <p className="text-xs text-muted-foreground flex items-center gap-1">
                        <Icon name="Mail" size={12} />
                        {member?.email}
                      </p>
                      <p className="text-xs text-muted-foreground flex items-center gap-1">
                        <Icon name="Phone" size={12} />
                        {member?.phone}
                      </p>
                      <p className="text-xs text-muted-foreground flex items-center gap-1">
                        <Icon name="Hash" size={12} />
                        {member?.membershipId}
                      </p>
                    </div>
                  </div>

                  <Icon name="ChevronRight" size={20} color="var(--color-muted-foreground)" />
                </div>
              </div>
        ) :

        <div className="text-center py-8">
              <Icon name="Search" size={48} color="var(--color-muted-foreground)" />
              <p className="mt-3 text-sm text-muted-foreground">No members found</p>
            </div>
        }
        </div>
      }
      {!searchQuery &&
      <div className="text-center py-8">
          <Icon name="Users" size={48} color="var(--color-muted-foreground)" />
          <p className="mt-3 text-sm text-muted-foreground">
            Start typing to search members
          </p>
        </div>
      }
    </div>);

};

export default MemberLookup;